// src/components/IntroSection.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './IntroSection.css'; // แนะนำแยก CSS

const IntroSection = ({ t, leftLinks = [], rightLinks = [], centerTextKey }) => {
  return (
    <div className="intro-section-container">
      {/* Header */}
      <h1 className="intro-header">" {t('intro_header')} "</h1>

      {/* Desktop Layout */}
      <div className="intro-section-desktop">
        {/* Left Cards */}
        <div className="cards-column">
          {leftLinks.map((link, idx) => (
            <Link key={idx} to={link.path} className="card-link">
              <div className="card">
                <h4>{t(link.titleKey)}</h4>
                {link.descKey && <p>{t(link.descKey)}</p>}
              </div>
            </Link>
          ))}
        </div>

        {/* Center Text */}
        <div className="center-text">
          <h2>{t('welcome_header')}</h2>
          <p>{t('welcome_text')}</p>
          <p>{t(centerTextKey)}</p>
        </div>

        {/* Right Cards */}
        <div className="cards-column">
          {rightLinks.map((link, idx) => (
            <Link key={idx} to={link.path} className="card-link">
              <div className="card">
                <h4>{t(link.titleKey)}</h4>
                {link.descKey && <p>{t(link.descKey)}</p>}
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="intro-section-mobile">
        <h2>{t('welcome_header')}</h2>
        <p>{t('welcome_text')}</p>
        <p>{t(centerTextKey)}</p>
      </div>
    </div>
  );
};

export default IntroSection;
